import { VoyagersClubMainContainerProps } from '@msc-b2c/interfaces/types';
import { VoyagersClubMainContainer } from './VoyagersClubMainContainer';
import { usePrivateAreaPageViewTracking } from '../utils/analyticsUtils';

export function VoyagersClubMainContainerWrapper({
  children,
}: Readonly<VoyagersClubMainContainerProps>) {
  usePrivateAreaPageViewTracking();

  const properties: VoyagersClubMainContainerProps = {
    children,
  };
  return <VoyagersClubMainContainer {...properties} />;
}

VoyagersClubMainContainerWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/voyagersclubmaincontainer';

export default VoyagersClubMainContainerWrapper;
